import React from "react";

import { LabelData } from "../../../../models/LabelData";
import Checkbox from "../../../FormElement/Checkbox";

import "./styles.scss";

export interface IPopupSelectLabelItemProps {
  label: LabelData;
  checked: boolean;
  onCheck: (label: LabelData) => void;
  onUncheck: (label: LabelData) => void;
  onDelete: (label: LabelData) => void;
  onUpdate: (label: LabelData) => void;
}

export const PopupSelectLabelItem: React.FunctionComponent<
  IPopupSelectLabelItemProps
> = (props) => {
  const { label, checked, onCheck, onUncheck, onDelete, onUpdate } = props;

  const handleChange = (checked: boolean) => {
    if (checked) {
      onCheck(label);
    } else {
      onUncheck(label);
    }
  };

  return (
    <div className="popup-select-label-item">
      <Checkbox
        checked={checked}
        label={label.name}
        id={`checkbox-select-label-${label.id}`}
        onChange={handleChange}
      />
      <div>
        <button className="btn" onClick={() => onDelete(label)}>
          <i className="icons icon-trash"></i>
        </button>
        <button className="btn" onClick={() => onUpdate(label)}>
          <i className="icons icon-pencil"></i>
        </button>
      </div>
    </div>
  );
};
